/**
 * Figma: https://www.figma.com/design/XwMQV9iBJ1Ec4sOzWMEZcK/-Dev--Customer-Hub-2.3-%E2%80%93-Phase-1?node-id=2226-105965&m=dev
 */

import ProductCard from '../cards/ProductCard'
import type { Environment } from '../../../App'
import { useLabel } from '../../../i18n'

import type { OrderItem } from '../types'

const HIDDEN_PRODUCT_CODES = new Set(['eGiftcardRefund'])

interface OrderItemsProps {
  items: OrderItem[]
  env?: Environment
  role?: 'customer' | 'style-advisor'
  onItemDetailsClick?: (item: OrderItem) => void
  onReturnDetailsClick?: (item: OrderItem) => void
  onCopyProductCode?: (code: string) => void
}

export default function OrderItems({
  items,
  env,
  role = 'customer',
  onItemDetailsClick,
  onReturnDetailsClick,
  onCopyProductCode,
}: OrderItemsProps) {
  const t = useLabel()
  const visibleItems = items.filter(
    (item) => !HIDDEN_PRODUCT_CODES.has(item.productCode),
  )

  if (visibleItems.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-16">
      <h2 className="text-xl leading-xl lg:text-2xl lg:leading-2xl font-medium text-text tracking-heading">
        {t('orderList.items.title')}
      </h2>
      <div className="flex flex-col gap-16 md:gap-20">
        {visibleItems.map((item) => (
          <ProductCard
            key={item.id}
            item={item}
            env={env}
            role={role}
            onItemDetailsClick={onItemDetailsClick}
            onReturnDetailsClick={onReturnDetailsClick}
            onCopyProductCode={onCopyProductCode}
          />
        ))}
      </div>
    </div>
  )
}
